import { useQuery } from '@tanstack/react-query';
import { getOrders, type OrdersListParams } from '../orders.api';

/** Server-state for the orderlijst (TanStack Query — never Zustand, per h3-2 anti-pattern guidance). */
export function useOrders(params: OrdersListParams) {
  return useQuery({
    queryKey: ['orders', 'list', params],
    queryFn: () => getOrders(params),
    staleTime: 30 * 1000,
  });
}
